import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import './App.css';

const API_KEY = '12d4804c753eeb488090dca2cb88491d'; // Reemplaza con tu API key de OpenWeatherMap

function App() {
  const [weatherData, setWeatherData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [city, setCity] = useState('Mendaro');

  
  const getWeatherData = useCallback(async () => {
    try {
      const response = await axios.get(
        `https://api.openweathermap.org/data/2.5/weather?q=${city}&units=metric&appid=${API_KEY}&lang=es`
      );
      console.log('Datos del clima:', response.data);
      console.log('Icono:', response.data.weather[0].icon);
      setWeatherData(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error al obtener datos del clima:', error);
      setLoading(false);
    }
  }, [city]);

  useEffect(() => {
    getWeatherData();
  }, [getWeatherData]);

  const handleCityChange = (event) => {
    setCity(event.target.value);
  };

  if (loading) {
    return <div className="App">Cargando...</div>;
  }

  if (!weatherData) {
    return <div className="App">No se pudo cargar la información del clima.</div>;
  }

  return (
    <div className="App">
      <h1>Weather App</h1>
      <input 
        type="text" 
        value={city} 
        onChange={handleCityChange} 
        placeholder="Introduce el nombre de la ciudad"
      />
      <div className="weather-info">
        <h2>{weatherData.name}</h2>
        {/*<img 
          src={`http://openweathermap.org/img/wn/${weatherData.weather[0].icon}.png`} 
          alt={weatherData.weather[0].description}
          className="weather-icon"
          onError={(e) => {
            console.error('Error al cargar la imagen');
            e.target.onerror = null; 
            e.target.alt = 'Icono no disponible';
          }}
        />*/}
        <p className="temperature">{Math.round(weatherData.main.temp)}°C</p>
        <p className="description">{weatherData.weather[0].description}</p>
        <p>Humedad: {weatherData.main.humidity}%</p>
        <p>Viento: {weatherData.wind.speed} m/s</p>
      </div>
    </div>
  );
}

export default App;